import AppFooter from "../Common/AppFooter";

const AuthLayout = ({ className = "bg-white", left, right }) => {
    return (
        <div className={`flex min-h-screen flex-col ${className} text-slate-900`}>
            <div className="grid flex-1 grid-cols-1 lg:grid-cols-2">
                {left}
                {right}
            </div>
            <AppFooter />
        </div>
    );
};

export default AuthLayout;
